<div class="ticket">
  <div class="ticket__card">
    <div
      class="ticket__card-header"
      [ngClass]="{
        'bg-gray-light': ticket.ticket_status.id === 1,
        'bg-blue-light': ticket.ticket_status.id === 2 || ticket.ticket_status.id === 3 || ticket.ticket_status.id === 7,
        'bg-pink-light': ticket.ticket_status.id === 4 || ticket.ticket_status.id === 5 || ticket.ticket_status.id === 9,
        'bg-green-light': ticket.ticket_status.id === 6 || ticket.ticket_status.id === 8
      }"
    >
      <div class="header__communicator_and_extra">
        <div class="grid">
          <div class="grid__box grid__box--size-6">
            <div class="grid grid--gap-4 color-gray-dark">
              <div class="grid__box grid__box--size-min">
                {{ ticket.hd_schedule_intbegin | dateFormat: 'HH:mm' }}
              </div>
              <div class="grid__box grid__box--size-min">-</div>
              <div class="grid__box grid__box--size-min">
                {{ ticket.hd_schedule_intend | dateFormat: 'HH:mm' }}
              </div>
            </div>
          </div>
          <div class="grid__box grid__box--size-6 grid__box--justify-content-flex-end">
            <ng-container *ngIf="ticket && ticket.ticket_type.id !== 4">
              <app-tickets-extra [ticket]="ticket"></app-tickets-extra>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="ticket && ticket.ticket_type.id === 4">
          <app-ticket-communicator-info [ticket]="ticket"></app-ticket-communicator-info>
        </ng-container>
      </div>
      <div class="mt-8">
        <div class="grid grid--gap-8">
          <div class="grid__box grid__box--size-min">
            <span class="font-weight-bold">ВК:</span>
          </div>
          <div class="grid__box grid__box--size-min">
            <span class="text-italic {{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
              {{ ticket.ticket_status && ticket.ticket_status.name }}
            </span>
          </div>
        </div>
        <div class="grid grid--gap-8">
          <div class="grid__box grid__box--size-min">
            <span class="font-weight-bold">HD:</span>
          </div>
          <div class="grid__box grid__box--size-min">
            <span class="text-italic">
              {{ ticket.hd_ticket_status.name }}
            </span>
          </div>
          <div class="grid__box ta-right" *ngIf="ticket.ticket_type.id !== 4 && ticket.hd_line_status_info != null">
            <span class="font-size-12 line-height-16 cursor-pointer line-status-refresh" (click)="refreshLineStatus($event)">
              <ng-container *ngIf="!isRefreshingLineStatus">
                <span class="color-red-dark" *ngIf="ticket.hd_line_status_info === 0">off</span>
                <span class="color-green-dark" *ngIf="ticket.hd_line_status_info === 1">on</span>
              </ng-container>
              <span class="line-status-refresh__spinner" *ngIf="isRefreshingLineStatus"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="ticket__card-content">
      <div class="grid grid--gap-8">
        <div class="grid__box grid__box--size-min">
          <app-tickets-types [ticket]="ticket"></app-tickets-types>
        </div>
        <div class="grid__box grid__box--size-8">
          <div class="text-ellipsis" title="{{ ticket.ticket_subtype }}" style="width: 165px" *ngIf="ticket.ticket_type && [3, 4, 5].indexOf(ticket.ticket_type.id) > -1">
            {{ ticket.ticket_subtype }}
          </div>
          <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && !ticket.extra_flags.moveaddr">
            <span class="color-red-dark">Нет сервисов</span>
          </ng-container>
          <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id !== 1">
            <app-tickets-services [services]="ticket.services" [ticket]="ticket"></app-tickets-services>
          </ng-container>
          <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && ticket.extra_flags.moveaddr">
            <app-tickets-services [services]="ticket.services" [ticket]="ticket"></app-tickets-services>
          </ng-container>
          <ng-container *ngIf="ticket.ticket_type.id === 2">
            <app-tickets-services [services]="ticket.services" [ticket]="ticket"></app-tickets-services>
          </ng-container>
        </div>
      </div>
      <div class="mt-8">
        <div class="grid">
          <div class="grid__box grid__box--size-7">
            <div class="font-weight-bold text-ellipsis cur-help" style="width: 125px" title="{{ ticket.district.district_name }}">
              {{ ticket.district.district_name }}
            </div>
          </div>
          <div class="grid__box grid__box--pull-right ta-right">
            <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]">
              {{ ticket.hd_ticket_number }}
            </a>
          </div>
        </div>
      </div>
      <div class="mt-8" *ngIf="ticket.extra_flags && ticket.extra_flags.ctn">
        <div class="grid">
          <div class="grid__box grid__box--size-7">
            <span class="font-weight-bold">CTN</span>
          </div>
          <div class="grid__box grid__box--pull-right ta-right">
            {{ ticket.extra_flags.ctn }}
          </div>
        </div>
      </div>
      <div class="mt-8 pos-r">
        <div class="card-content__address cur-help" title="{{ ticket.hd_address }}">
          {{ ticket.hd_address }}
        </div>
      </div>
      <div class="mt-8">
        <div class="grid">
          <div class="grid__box grid__box--size-6 no-wrap">
            <app-ticket-global-problem-check [ticket]="ticket"></app-ticket-global-problem-check>
          </div>
          <div class="grid__box grid__box--size-6 grid__box--pull-right">
            <div class="text-ellipsis no-wrap ta-right" *ngIf="ticket.brigade" title="{{ ticket.brigade.brigade_name }}">
              <app-brigade-popover [brigade]="ticket.brigade"></app-brigade-popover>
            </div>
            <app-tickets-brigade-assign
              [ticket]="ticket"
              [filter]="filter"
              [ticketsCurrentFilter]="ticketsCurrentFilter"
              [brigadeAssign]="brigadeAssign"
              [ticketsMultipleAssign]="ticketsMultipleAssign"
              [index]="intervalIndex"
            ></app-tickets-brigade-assign>
          </div>
        </div>
      </div>
    </div>
    <div class="ticket__card-assign">
      <div class="card-assign__wrapper" *ngIf="ticket.ticket_status.id !== 6 && ticket.ticket_status.id !== 8">
        <app-ticket-checker [ticket]="ticket" [ticketsMultipleAssign]="ticketsMultipleAssign" [ticketsCurrentFilter]="ticketsCurrentFilter" [isMatrix]="true"></app-ticket-checker>
      </div>
    </div>
  </div>
</div>
